@if (embedReady) {
<app-api-embed [family]="family" [api]="api" [apiItem]="apiItem" [version]="version" [apiKey]="apiKey"></app-api-embed>
} @if (getapikeyInfoModal) {
<div>
  <modal [visible]="true" (visibleChange)="closeInfoModal()" [secondaryModal]="true" [title]="'Not logged in !'">
    <div>
      <p class="-fontSmall -colorAccentGrey -description-padding">You must login to access this feature</p>
      <div>
        <wpbutton type="submit" to="/dashboard/login">Login</wpbutton>
        <wpbutton type="submit" to="/dashboard/create-account">Create a free account</wpbutton>
      </div>
    </div>
  </modal>
</div>
}
